import type { SVGProps } from 'react';

/**
 * Conjunto de icones da aplicacao.
 *
 * Os icones sao desenhados aqui em vez de virem de uma biblioteca porque a
 * quantidade usada e pequena e previsivel. Isso evita carregar um pacote inteiro
 * para exibir vinte simbolos e mantem o traco consistente com a marca.
 */

export type IconName =
  | 'dashboard'
  | 'clock'
  | 'users'
  | 'briefcase'
  | 'coins'
  | 'shield'
  | 'gavel'
  | 'target'
  | 'file'
  | 'stamp'
  | 'signature'
  | 'send'
  | 'bank'
  | 'refresh'
  | 'close'
  | 'alert'
  | 'percent'
  | 'layers'
  | 'copy'
  | 'lock'
  | 'plug'
  | 'settings'
  | 'logout'
  | 'menu'
  | 'chevronLeft'
  | 'chevronRight'
  | 'check'
  | 'sparkle'
  | 'chart'
  | 'eye';

const paths: Record<IconName, string> = {
  dashboard: 'M4 4h6v7H4zM14 4h6v4h-6zM14 12h6v8h-6zM4 15h6v5H4z',
  clock: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM12 7.5V12l3 2',
  users:
    'M9 4.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4ZM3.5 20c.6-3.6 3-5.6 5.5-5.6s4.9 2 5.5 5.6M17 5.9a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2ZM15.8 14.7c2.2.3 4 2.1 4.5 5.3',
  briefcase: 'M3 7.5h18v12H3zM8.5 7.5V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.5M3 12.5h18',
  coins:
    'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 6.5v11M15 9.2c-.4-1-1.4-1.7-3-1.7-1.9 0-3.2.9-3.2 2.3 0 3 6.2 1.5 6.2 4.4 0 1.4-1.3 2.4-3.2 2.4-1.6 0-2.7-.6-3.2-1.7',
  shield: 'M12 3.2 5 6v6c0 4.6 3 7.6 7 8.8 4-1.2 7-4.2 7-8.8V6l-7-2.8ZM9 12l2 2 4-4.2',
  gavel: 'm9.5 6.5 4 4-6 6-4-4 6-6Zm4-4 4 4M17.5 6.5l4 4M2.5 21.5h9m0-9 6-6',
  target:
    'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM12 7.3a4.7 4.7 0 1 0 0 9.4 4.7 4.7 0 0 0 0-9.4ZM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
  file: 'M7 3.5h7l4 4V20a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1ZM14 3.5V8h4M9 13h6M9 16.5h6',
  stamp:
    'M8.5 3.5h7L17 9H7l1.5-5.5ZM6 15.5h12l1.5 5H4.5l1.5-5ZM9 9v3.5M15 9v3.5M6 15.5l1-3h10l1 3',
  signature:
    'M3 17c2-4.5 3.5-7 5-7 1.7 0 1 4.5 2.5 4.5S13 8 15 8s1 6 2.5 6 1.7-1.5 3.5-1.5M3 20.5h18',
  send: 'm4 4 16 8-16 8 3-8-3-8ZM7 12h10',
  bank: 'M3.5 9.5 12 4l8.5 5.5M5 9.5v9M9.5 9.5v9M14.5 9.5v9M19 9.5v9M3.5 19h17',
  refresh:
    'M4 12a8 8 0 0 1 13.7-5.7L20 8.5M20 4v4.5h-4.5M20 12a8 8 0 0 1-13.7 5.7L4 15.5M4 20v-4.5h4.5',
  close: 'm6 6 12 12M18 6 6 18',
  alert:
    'M10.3 4.5 2.9 18a1.7 1.7 0 0 0 1.5 2.5h15.2A1.7 1.7 0 0 0 21.1 18L13.7 4.5a1.7 1.7 0 0 0-3.4 0ZM12 10v4M12 16.8v.4',
  percent:
    'M7 4.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2ZM17 14.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2ZM18 6 6 18',
  layers:
    'm12 3 8.5 4.5L12 12 3.5 7.5 12 3Zm-8.5 9 8.5 4.5 8.5-4.5m-17 4.5 8.5 4.5 8.5-4.5',
  copy: 'M8.5 8.5h11.5V20H8.5zM15 8.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2.5',
  lock: 'M5 10.5h14v10H5zM8 10.5V7.5a4 4 0 0 1 8 0v3',
  plug: 'M13 3 5 13.5h5.5L11 21l8-11h-5.5L13 3Z',
  settings:
    'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM19.4 13.5a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V19a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H4a2 2 0 1 1 0-4h.2a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H10a1.6 1.6 0 0 0 1-1.5V4a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V10a1.6 1.6 0 0 0 1.5 1H20a2 2 0 1 1 0 4h-.2a1.6 1.6 0 0 0-1.4 1Z',
  logout: 'M9 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3M15 16.5 20 12l-5-4.5M20 12H9',
  menu: 'M4 6.5h16M4 12h16M4 17.5h16',
  chevronLeft: 'm15 6-6 6 6 6',
  chevronRight: 'm9 6 6 6-6 6',
  check: 'M5 12.5 10 17 19 7',
  sparkle:
    'M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18',
  // Relatorios (P-BI-1): colunas sobre a linha de base.
  chart: 'M4 20h16M7 20v-6M12 20V6M17 20v-9',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
};

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 18, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={paths[name]} />
    </svg>
  );
}
